<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { RouterView } from 'vue-router'
import SideNavView from './views/SideNavView.vue'
import NavigationView from './views/NavigationView.vue'
import AppFooter from './components/AppFooter.vue'
import { useLayoutStore } from './stores/layout'
import { useNotefieIdStore } from './stores/notefieID'

const layoutStore = useLayoutStore()
const notefieIdStore = useNotefieIdStore()
const { notefieID, siteLocation } = storeToRefs(notefieIdStore)
const routerContextKey = computed(() => `${notefieID.value}\0${siteLocation.value}`)

const primaryPink = '#E25A64'
import { NConfigProvider } from 'naive-ui'
/**
 * Use this for type hints under js file
 * @type import('naive-ui').GlobalThemeOverrides
 */

const themeOverrides = {
  common: {
    primaryColor: primaryPink,
    primaryColorHover: primaryPink
  },
  DataTable: {
    loadingColor: primaryPink,
    thIconColorActive: primaryPink
  },
  Button: {
    colorPrimary: primaryPink,
    colorHoverPrimary: '#000000',
    borderPrimary: primaryPink,
    borderHoverPrimary: '#000000',
    colorFocusPrimary: '#4e4e4e',
    borderFocusPrimary: primaryPink,
    colorPressedPrimary: primaryPink,
    rippleColorPrimary: primaryPink
  },
  Input: {
    borderHover: '1px solid #E25A64',
    borderFocus: '1px solid #E25A64',
    boxShadowFocus: '0 3px 10px rgb(226 90 100 / 0.4)'
  }
}
</script>

<template>
  <n-config-provider :theme-overrides="themeOverrides">
    <n-message-provider>
      <div class="app-wrapper">
        <div class="container-fluid">
          <SideNavView v-if="layoutStore.showSidenav" />
          <main>
            <NavigationView v-if="layoutStore.showNavbar" />
            <RouterView :key="routerContextKey" />
          </main>
        </div>
        <AppFooter />
      </div>
    </n-message-provider>
  </n-config-provider>
</template>

<style lang="scss">
@import './assets/styles.scss';

.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.container-fluid {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

main {
  flex: 1;
  overflow-y: auto;
}
</style>
